export const isCustomFormType = formType => formType === 'CUSTOM'



// WEBPACK FOOTER //
// ./src/utils/dataSetReport/isCustomFormType.js